





































import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import Dialogs from "@/store/modules/Dialogs";

const dialogs = getModule(Dialogs)

@Component({
    components: {}
})
export default class ScoringKeyButtonTrigger extends Vue {

    @Prop()
    viewpointId!: string;

    @Prop()
    resourceId!: string

    @Prop()
    tooltip!: string;

    private selectScoringKeyEdit() {
        dialogs.editScoringKey({viewpointId: this.viewpointId, resourceId: this.resourceId})
    }

}
